import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Airport } from '../../airport/models/airport.model';
import { BusinessManagerService } from '../user/business-manager.service';
import { AuthService } from '../../auth/auth/auth.service';
import { FlightbridgeService } from '../services/flightbridge.service';
import { environment } from '../../../environments/environment';
import { formatDate } from '@angular/common';
import { AviationEvent } from '../models/aviation-event.model';
import * as moment from 'moment-timezone';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
var FlightbridgeComponent = /** @class */ (function () {
    function FlightbridgeComponent(_businessManagerService, _auth, _flightbridgeService, _analyticsService) {
        this._businessManagerService = _businessManagerService;
        this._auth = _auth;
        this._flightbridgeService = _flightbridgeService;
        this._analyticsService = _analyticsService;
        this.airport = null;
        this.aviationEvent = null;
        this.isLoggedIn = false;
        this.isMember = false;
    }
    FlightbridgeComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this._auth.authenticated && this._auth.endUser)) return [3 /*break*/, 2];
                        this.isLoggedIn = true;
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isMember()];
                    case 1:
                        _a.isMember = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    FlightbridgeComponent.prototype.navigateToFlightBridge = function (pageType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ssoRetval, firstDateString, nextDateString, startMoment, endMoment, firstDate, nextDate, airportIdent, URL;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._flightbridgeService.postFlightBridgeSSOInitial()];
                    case 1:
                        ssoRetval = _a.sent();
                        firstDateString = null;
                        nextDateString = null;
                        if (this.aviationEvent && this.aviationEvent.startDateTime && this.aviationEvent.endDateTime) {
                            startMoment = moment.tz(this.aviationEvent.startDateTime, 'UTC');
                            firstDateString = startMoment.clone().tz(this.aviationEvent.timezone).format('YYYY-MM-DD');
                            endMoment = moment.tz(this.aviationEvent.endDateTime, 'UTC');
                            nextDateString = endMoment.clone().tz(this.aviationEvent.timezone).format('YYYY-MM-DD');
                        }
                        else {
                            firstDate = new Date();
                            firstDate.setDate(firstDate.getDate() + 1);
                            firstDateString = formatDate(firstDate, 'yyyy-MM-dd', 'en-US');
                            nextDate = new Date();
                            nextDate.setDate(nextDate.getDate() + 3);
                            nextDateString = formatDate(nextDate, 'yyyy-MM-dd', 'en-US');
                        }
                        airportIdent = null;
                        if (this.airport) {
                            airportIdent = this.airport.faaId;
                        }
                        else if (this.aviationEvent && this.aviationEvent.airportIdent) {
                            airportIdent = this.aviationEvent.airportIdent;
                        }
                        URL = '';
                        if (pageType === 'hotel') {
                            this._analyticsService.trackEvent('airport_flightbridge_hotel', '', '');
                            if (airportIdent) {
                                // tslint:disable-next-line:max-line-length
                                URL = environment.flightBridgeHotelUrl + "&UserAuthenticationToken=" + ssoRetval.token + "&AirportCode=" + airportIdent + "&CheckInDate=" + firstDateString + "&CheckOutDate=" + nextDateString;
                                this._analyticsService.trackEvent('airport_flightbridge_hotel-specific', airportIdent, airportIdent);
                            }
                            else {
                                // tslint:disable-next-line:max-line-length
                                URL = environment.flightBridgeAnywhereHotelUrl + "&UserAuthenticationToken=" + ssoRetval.token + "&CheckInDate=" + firstDateString + "&CheckOutDate=" + nextDateString;
                            }
                        }
                        else if (pageType === 'rentalcar') {
                            this._analyticsService.trackEvent('airport_flightbridge_rentalcar', '', '');
                            if (airportIdent) {
                                // tslint:disable-next-line:max-line-length
                                URL = environment.flightBridgeRentalCarUrl + "&UserAuthenticationToken=" + ssoRetval.token + "&AirportCode=" + airportIdent + "&CheckInDate=" + firstDateString + "&CheckOutDate=" + nextDateString;
                                this._analyticsService.trackEvent('airport_flightbridge_rentalcar-specific', airportIdent, airportIdent);
                            }
                            else {
                                // tslint:disable-next-line:max-line-length
                                URL = environment.flightBridgeAnywhereRentalCarUrl + "&UserAuthenticationToken=" + ssoRetval.token + "&CheckInDate=" + firstDateString + "&CheckOutDate=" + nextDateString;
                            }
                        }
                        else {
                            // tslint:disable-next-line:max-line-length
                            URL = environment.flightBridgeAirlineUrl + "&UserAuthenticationToken=" + ssoRetval.token + "&CheckInDate=" + firstDateString + "&CheckOutDate=" + nextDateString;
                            this._analyticsService.trackEvent('airport_flightbridge_airline', '', '');
                        }
                        window.open(URL);
                        return [2 /*return*/];
                }
            });
        });
    };
    FlightbridgeComponent.prototype.navigateToJoinAOPA = function () {
        window.open('https://www.aopa.org/account/multipagejoin');
    };
    FlightbridgeComponent.prototype.navigateToLogin = function () {
        window.open('https://www.aopa.org/login');
    };
    return FlightbridgeComponent;
}());
export { FlightbridgeComponent };
